import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import styles from './PartnerInformation.module.scss';

const PartnerInformation = ({ phone, phoneText, address, url, mail }) => {
    const { t } = useTranslation('common');
    let prettyUrl;

    // prettyUrl = from protocol://some.com/url/hello/ -> some.com/url/hello/
    if ('URL' in window && url) {
        prettyUrl = new URL(url).host;
    } else {
        // IE 11
        prettyUrl = url.replace(/(^\w+:|^)\/\//, '');
    }

    return (
        <div className={styles['PartnerInformation']}>
            <div className={styles['PartnerInformation__Info']}>
                <h2 className={styles['PartnerInformation__Header']}>
                    {t('partnerInformation.header')}
                </h2>

                <ul>
                    {phone && (
                        <li className={styles['PartnerInformation__Item']}>
                            <a
                                className={
                                    styles['PartnerInformation__ListLink']
                                }
                                href={`tel://${phone}`}>
                                <span
                                    className={
                                        styles['PartnerInformation__Icon'] +
                                        ' ' +
                                        styles[
                                            'PartnerInformation__Icon--Phone'
                                        ]
                                    }
                                    aria-hidden={true}
                                />
                                {phone}
                            </a>
                            {phoneText && (
                                <p
                                    className={
                                        styles['PartnerInformation__Text']
                                    }>
                                    {phoneText}
                                </p>
                            )}
                        </li>
                    )}
                    {mail && (
                        <li className={styles['PartnerInformation__Item']}>
                            <a
                                className={
                                    styles['PartnerInformation__ListLink']
                                }
                                href={`mailto:${mail}`}>
                                <span
                                    className={
                                        styles['PartnerInformation__Icon'] +
                                        ' ' +
                                        styles['PartnerInformation__Icon--Mail']
                                    }
                                    aria-hidden={true}
                                />
                                {mail}
                            </a>
                        </li>
                    )}
                    {address && (
                        <li className={styles['PartnerInformation__Item']}>
                            <a
                                className={
                                    styles['PartnerInformation__ListLink']
                                }
                                href={address}>
                                <span
                                    className={
                                        styles['PartnerInformation__Icon'] +
                                        ' ' +
                                        styles[
                                            'PartnerInformation__Icon--Marker'
                                        ]
                                    }
                                    aria-hidden={true}
                                />
                                {t('partnerInformation.directions')}
                            </a>
                        </li>
                    )}
                </ul>
            </div>

            <div className={styles['PartnerInformation__LinkWrap']}>
                <a className={styles['PartnerInformation__Link']} href={url}>
                    {prettyUrl}
                    <div
                        className={
                            styles['PartnerInformation__Icon'] +
                            ' ' +
                            styles['PartnerInformation__Icon--Arrow']
                        }
                        aria-hidden={true}
                    />
                </a>
            </div>
        </div>
    );
};

PartnerInformation.propTypes = {
    phone: PropTypes.string,
    mail: PropTypes.string,
    phoneText: PropTypes.string,
    address: PropTypes.string,
    url: PropTypes.string,
};

PartnerInformation.defaultProps = {
    phone: '',
    mail: '',
    phoneText: '',
    address: '',
    url: '',
};

export default PartnerInformation;
